import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-readonly-input',
  templateUrl: './readonly-input.component.html',
  styleUrl: './readonly-input.component.sass'
})

export class ReadonlyInputComponent {
  
  @Input() showAsterisk: boolean = false;
  @Input() toolTipTitle: string  = '';
  @Input() showToolTip: boolean = false;
  @Input() customWidth: number = 0;
  @Input() label: string
  @Input() value: string = ""
  @Input() disabled: boolean = true
  @Input() readonly: boolean = true
  @Input() showCopyBtn: boolean = true
  @Input() lableWidth: number = 1
  @Input() inputWidth: number = 6
  @Input() paddingHorizontal: number = 3 

  isCopying: boolean = false

  copyValue(): void {

    if (this.value && !this.isCopying) {

      this.isCopying = true

      navigator.clipboard.writeText(this.value.trim()).then(() => {
        this.showCopyButton()
      })

    }
    
  }

  private showCopyButton(): void {
    setTimeout(() => {
      this.isCopying = false
    }, 1000)
  }

}
